import { ErrorNotification } from "./ErrorNotification"
import { RunningNotification } from "./RunningNotification"
import { SuccessNotification } from "./SuccessNotification"

import styles from "./NotificationTemplate.module.scss"

import type { Actions, TaskState } from "@/organisms/TaskProvider"
import type { NotificationProps, Payload, Result } from "./open-pr.types"

export const getPrType = (state: TaskState<Payload, Result>) =>
  state.payload?.sourceControl === "GitLab" ? "mr" : "pr"

export const getText = (
  tKey: string,
  props: NotificationProps,
  prefix = "notifications.prTask.type"
) =>
  props.actions.t(tKey, {
    type: props.actions.t(`${prefix}.${getPrType(props.state)}`)
  })

export const notificationOnStateChange =
  (actions: Actions) => (state: TaskState<Payload, Result>) => {
    const attr = { duration: 0, className: styles.notification }
    const props = { state, actions, getText }

    if (state.status === "running")
      actions.openNotification({
        message: RunningNotification(props),
        ...attr
      })

    if (state.status === "success")
      actions.openNotification({
        message: SuccessNotification(props),
        ...attr
      })

    if (state.status === "error")
      actions.openNotification({
        message: ErrorNotification(props),
        ...attr
      })
  }
